import { memo } from "react";
import { useTranslation } from "react-i18next";
import useBoolean from "hooks/useBoolean";
import Button from "components/Button";
import TrashIcon from "components/Icons/TrashIcon";
import DeleteMeasurementDialog from "./DeleteMeasurementDialog";

interface DeleteMeasurementActionProps {
  measurementId: string;
}

function DeleteMeasurementAction(props: DeleteMeasurementActionProps) {
  const { measurementId } = props;
  const { t } = useTranslation();
  const { value: open, toggle } = useBoolean();

  return (
    <>
      <Button size="small" variant="danger" startIcon={<TrashIcon color="error" />} onClick={toggle}>
        {t("global.delete_button_text")}
      </Button>
      <DeleteMeasurementDialog measurementId={measurementId} open={open} onClose={toggle} />
    </>
  );
}

export default memo(DeleteMeasurementAction);
